export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mb-10">
          欢迎投稿、合作或反馈，每日大赛入口期待与你交流
        </p>

        <div className="rounded-2xl border border-background-200/80 bg-background-50 p-8 md:p-10">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-2xl text-primary-600"></i>
          </div>
          <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-2">
            投稿与合作
          </h3>
          <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-md mx-auto">
            如果你有优秀的大赛作品推荐、合作意向或内容建议，欢迎通过以下方式联系我们。
            每日大赛入口持续收录各类大赛视频，期待你的投稿让每日大全更加丰富。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-background-100 border border-background-200/70">
              <i className="ri-mail-line text-primary-500"></i>
              <span className="text-sm text-foreground-700">contact@meiridasai.com</span>
            </div>
            <div className="flex items-center gap-2 px-5 py-3 rounded-lg bg-background-100 border border-background-200/70">
              <i className="ri-wechat-line text-accent-600"></i>
              <span className="text-sm text-foreground-700">每日大赛入口官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}